import { useContext } from 'react';
import { ThemeContext } from 'providers/ThemeProvider';
import { ThemeContextValue } from 'types/theme';

export const useTheme = (): ThemeContextValue => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};
